import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateEstablishment from "./CreateEstablishment";
import EditEstablishment from "./EditEstablishment";
import DeleteEstablishment from "./DeleteEstablishment";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useEstablishmentsDataViewLogic } from "./hooks/useEstablishmentsDataViewLogic";
import { Navigate } from "react-router-dom";


const EstablishmentsDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    apiTotalRecords
  } = useEstablishmentsDataViewLogic();

  const AddEstablishmentButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέο Κατάστημα`)}
      </Button>
    )
  };

  const ButtonsAreaRightContainer: React.FC = () => {
    return (
      <>
        <AddEstablishmentButton />
      </>
    )
  }

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} showDetails={selectedRowsOfTable.length > 0} />
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No Establishments yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={ButtonsAreaRightContainer}
                hiddenColumnsForUser={["deleted", "id"]}
                textPosition="center"
                maxHeight="33rem"
                showNumberOfRows={true}
                numberOfRows={apiTotalRecords}
                numberOfRowsTitle="καταστήματα"
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="md"
          >
            {modalEvent.action === "create" && <CreateEstablishment handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditEstablishment handleCloseModal={closeActionModal} establishmentId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteEstablishment handleCloseModal={closeActionModal} establishmentId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {modalEvent.action === "showDetails" && 
          <Navigate to={`/configuration/unitconfiguration/detailspage/Establishments/unittype/${modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1}/unitid`} />
        }

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default EstablishmentsDataView;

